export const LENSSTUDIO_SUPPORT_EMAIL = "lensstudio-support@snapchat.com";
